import Image from "next/image";
import React, { useState, useEffect } from "react";
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import Icons from "../../../public/icons/screeningChecksIcons";
import Link from "next/link";

const ScreeningChecks = ({ checks, hideBtn = false }) => {
  // console.log("data",data)
  const [hover, setHover] = useState(false);
  const [cardInd, setCardInd] = useState(0);
  const [cardName, setCardName] = useState("");
  const [invisible, setInvisible] = useState([true, true, true, true, true, true, true, true, true]);
  const updateVisibility = (index, value) => {
    setInvisible(prevState => {
      const newState = [...prevState];
      newState[index] = value;
      // console.log(newState);
      return newState;
    });
  }


  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: Math.min(i * 0.1, 1.5),
      },
    }),
  };
  const controls = useAnimation();
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0,
  });

  useEffect(() => {
    if (inView) {
      controls.start('visible');
    } else {
      controls.start('hidden');
    }
  }, [controls, inView]);

  return (
    <div className="lg:py-[20px] max-[400px]:pt-[10px] pt-[20px] xl:mt-[50px] lg:px-[120px] min-[400px]:px-[20px] text-center">
      <div className="xl:mx-[13%] flex flex-col items-center justify-center">
        <h2 className={`g-b text-center heading max-md:text-[25px] ${checks?.title.split(' ')[0] === 'Gig' ? 'xl:w-[500px]' : 'xl:w-[600px]'}`}>
          {checks?.title}
        </h2>
        {/* <p className='text-center text-[#fff] text-[18px]'> {data?.description}</p> */}
        <p className='g-r xl:w-[600px] min-[1600px]:w-full leading-6 text-center max-sm:px-5'>{checks?.description}</p>
      </div>
      <div ref={ref} className={`grid md:grid-cols-2 xl:grid-cols-3 grid-cols-1 gap-[50px] w-full min-[400px]:p-[35px] p-[25px] rounded-[20px]`}>
        {checks?.list.length && checks?.list.map((item, index) => (
          <Link href={item?.link ? item.link : ""} onClick={(e) => {
            if (!item?.link) e.preventDefault();
          }} key={index} className={``}>
            <motion.div
              custom={index}
              initial="hidden"
              animate={controls}
              variants={cardVariants}
              onMouseMove={() => { setHover(true); setCardInd(index); setCardName(item?.title) }}
              onMouseOut={() => setHover(false)}
              className={`flex flex-col items-center h-full rounded-[20px] p-3 pt-4 border-2 border-[#f0f4f7] group bg-cover bg-no-repeat ${index === 0 ? "bg-[url('/images/checks-shapes0.png')]" : index === 1 ? "bg-[url('/images/checks-shapes1.png')]" : index === 2 ? "bg-[url('/images/checks-shapes2.png')]" : index === 3 ? "bg-[url('/images/checks-shapes3.png')]" : index === 4 ? "bg-[url('/images/checks-shapes4.png')]" : index === 5 ? "bg-[url('/images/checks-shapes5.png')]" : index === 6 ? "bg-[url('/images/checks-shapes6.png')]" : index === 7 ? "bg-[url('/images/checks-shapes7.png')]" : "bg-[url('/images/checks-shapes8.png')]"}`} key={item?.title} onMouseOver={() => updateVisibility(index, false)} onMouseLeave={() => updateVisibility(index, true)}>
              <span className=" rounded-[20px] p-2 flex items-center justify-center min-w-[70px] max-w-[70px] h-[70px]">
                {typeof item?.icon === 'function' || typeof item?.icon === 'object' ? (
                  <item.icon size={32} className="text-[#168DEF]" />
                ) : (
                  <Icons name={item?.icon} hoverColor={hover ? true : false} Index={checks?.title.split(' ')[0] === 'Gig' ? "" : cardInd} LastIndex={checks?.title.split(' ')[0] === 'Gig' ? cardInd : ""} cardName={cardName} />
                )}
              </span>
              <h2 className='g-sm mt-4 text-[#3A3D46] text-[22px] max-md:text-[20px]'>{item?.title}</h2>
              <p className='g-m mb-0 leading-6 pb-2 flex-grow-1'>{item?.description}</p>
              {!hideBtn && <button className={`g-sm text-[#168DEF] group-hover:underline decoration-1 flex items-center relative right-0 group-hover:right-[20px] transition-all duration-400 pt-1`} >Learn more
                <span className={`${invisible[index] ? 'invisible' : ''} mt-[3px] absolute left-[70px] group-hover:left-[90px]  group-hover:visible duration-400`}><svg width="12" height="12" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5607 13.8547C10.2669 13.6193 10.0825 13.2814 10.0479 12.9153C10.0132 12.5492 10.1313 12.1848 10.376 11.9023L13.2145 8.62875L1.86908 8.62875C1.4865 8.62875 1.1196 8.48265 0.849075 8.22261C0.578554 7.96256 0.426576 7.60987 0.426576 7.24211C0.426576 6.87435 0.578554 6.52165 0.849075 6.2616C1.1196 6.00156 1.4865 5.85547 1.86908 5.85547L13.212 5.85547L10.376 2.58475C10.1313 2.30227 10.0132 1.93793 10.0479 1.57182C10.0825 1.2057 10.2669 0.867793 10.5607 0.632366C10.7062 0.515661 10.8742 0.427673 11.0552 0.373429C11.2361 0.319185 11.4264 0.29975 11.6152 0.316233C11.8039 0.332717 11.9874 0.384796 12.1553 0.469494C12.3231 0.554193 12.4719 0.66985 12.5931 0.809856L17.1949 6.11863C17.2097 6.12961 17.2244 6.14088 17.2388 6.15243C17.3865 6.27079 17.5082 6.41637 17.5966 6.5806C17.6849 6.74483 17.7382 6.92439 17.7534 7.10871C17.757 7.15365 17.7584 7.19866 17.7576 7.24356C17.7584 7.28846 17.757 7.33346 17.7534 7.37839C17.7382 7.56271 17.6849 7.74227 17.5966 7.9065C17.5082 8.07073 17.3865 8.21631 17.2388 8.33467C17.2244 8.34622 17.2097 8.35749 17.1949 8.36847L12.5931 13.6772C12.4719 13.8173 12.3231 13.9329 12.1553 14.0176C11.9874 14.1023 11.8039 14.1544 11.6152 14.1709C11.4264 14.1874 11.2361 14.1679 11.0552 14.1137C10.8742 14.0594 10.7062 13.9714 10.5607 13.8547Z" fill="#168DEF" />
                </svg></span>
              </button>}
            </motion.div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ScreeningChecks;
